import type { LucideIcon } from 'lucide-react';

export function StubPage({
  icon: Icon,
  title,
  description,
}: {
  icon: LucideIcon;
  title: string;
  description: string;
}) {
  return (
    <div className="p-8 max-w-3xl mx-auto">
      <header className="mb-6">
        <h1 className="text-2xl font-semibold text-gray-900">{title}</h1>
        <p className="text-sm text-gray-500 mt-1">{description}</p>
      </header>
      <div className="flex flex-col items-center justify-center py-20 text-gray-400 border border-dashed border-gray-200 rounded-xl bg-gray-50/40">
        <Icon size={32} strokeWidth={1.5} />
        <p className="mt-3 text-sm">Coming soon</p>
      </div>
    </div>
  );
}
